import request from '@/utils/ajax';

/**
 * //微信公众号列表
 * @param data
 * @returns {*}
 */
export function queryWxPublicAccountList(data){
  return request({
    url: `/wx/manage/wxAccount/list`,
    method: 'get',
  });
}

/**
 * /微信公众号粉丝列表
 * @param data
 * @returns {*}
 */
export function queryWxPublicAccountFansList(data){
  return request({
    url: `/wx/manage/wxUser/listWithoutCookie`,
    method: 'get',
    params: data
  });
}

/**
 * 个人微信好友列表
 * @param data
 * @returns {*}
 */
export function queryPersonalWxFriendsList(data){
  return request({
    url: `/wx/manage/wxBotClientFriend/list`,
    method: 'get',
    params: data
  });
}

/**
 * 个人微信机器人列表
 * @param data
 * @returns {*}
 */
export function queryPersonalWxBotList(data){
  return request({
    url: `/wx/manage/wxBotClientInfo/list`,
    method: 'get',
    params: data
  });
}

/**
 * 获取爬虫策略列表
 * @param data
 * @returns {*}
 */
export function queryReptileStrategyList(data){
  return request({
    url: `/wx/manage/forwardStrategy/scheduledSpiderSource`,
    method: 'get',
    params: data
  });
}

/**
 * 保存策略
 * @param data
 * @returns {*}
 */
export function saveStrategy(data){
  return request({
    url: `/wx/manage/forwardStrategy/save`,
    method: 'post',
    data: data
  });
}

/**
 * 更新策略
 * @param data
 * @returns {*}
 */
export function updateStrategy(data){
  return request({
    url: `/wx/manage/forwardStrategy/update`,
    method: 'put',
    data: data
  });
}
/**
 * 删除策略 暂没有 todo
 * @param data
 * @returns {*}
 */
export function deleteStrategy(data){
  return request({
    url: `/wx/manage/forwardStrategy/delete`,
    method: 'post',
    data: data
  });
}
